import { assoc, compose, prop, omit, split, last } from 'ramda';

import { isReplacing } from 'helpers/dictionariesHelpers';
import { formatDate, dateToStr } from './commonMapper';
import evolve, { toNumber } from './evolve';

export const RequestMapper = {
    replacing: (field, { reason }) => {
        return isReplacing(parseInt(reason, 10)) ? toNumber(field) : undefined;
    },
    languages: ({ id, level }) => {
        return id ? {
            id: toNumber(id),
            level: level ? toNumber(level) : null,
        } : undefined;
    },
    amount: ({from, to}) => {
        return {
            from: from ? parseFloat(from) : from,
            to: to ? parseFloat(to) : to
        };
    }
};

export const RequestDecode = evolve({
    comments: { date: formatDate },
    deadline: formatDate,
    date: formatDate
});

export const RequestCountersMapper = counters => compose(
    omit('notread'),
    assoc('inwork', prop('inwork', counters) + prop('notread', counters))
)(counters);

export const addRequestEncode = evolve({
    replacing: RequestMapper.replacing,
    languages: RequestMapper.languages,
    deadline: dateToStr,
    organization: toNumber,
    quantity: toNumber,
    responsible: toNumber,
    probation: toNumber,
    reason: toNumber,
    budget: toNumber,
    department: toNumber,
    town: toNumber,
    sex: toNumber,
    experience: toNumber,
    salary: {
        amount: {
            from: toNumber,
            to: toNumber
        },
        currency: toNumber,
        type: toNumber
    },
    schedule: toNumber,
    worktype: toNumber,
    education: {
        level: toNumber
    },
    age: {
        from: toNumber,
        to: toNumber
    },
    workplace: toNumber,
    kadrsyst: {
        legal: toNumber,
        department: toNumber,
        cell: toNumber,
        rolecode: toNumber,
        departchiefkey: toNumber,
    },
});

const getAddRequestId = compose(Number, last, split('/'));
export const addRequestDecode = (data, request) => {
    if (data) {
        return evolve({
            request: RequestDecode
        })(data);
    } else {
        return getAddRequestId(request.headers.location);
    }
}
